import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowUpCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-up-circle, arrow-top"} maskId="square-filled-radius-0-stroke-1-IconArrowUpCircle"><path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 6.79289L16.2071 11L15.5 11.7071L12.5 8.70711V17H11.5V8.70711L8.5 11.7071L7.79289 11L12 6.79289Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowUpCircle;
